import React, { useState, useEffect } from 'react';
import { TextField, Button, IconButton, Box } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';

export default function ContactNumberField({
	formValues,
	handleChange,
	errors,
	setFormValues,
	setVerificationContact,
	contactNumbers,
}: any) {
	const [verified, setVerified] = useState(false);
	const [verifyIcon, setVerifyIcon] = useState<string | null>(null);
	console.log(formValues, 'formValues');
	const Verifi = contactNumbers ? true : localStorage.getItem('otp-verified');
	const savedNumber = localStorage.getItem('vendorperson');
	useEffect(() => {
		// 🔹 Check if vendorperson exists in localStorage
		setFormValues({
			contactNumber: contactNumbers || savedNumber || '',
		});
		if (Verifi) {
			setVerified(true); // auto mark as verified
		}

		// Example: icon name saved in localStorage
		const icon = localStorage.getItem('verifyIcon'); // e.g. 'phone' or 'check'
		setVerifyIcon(icon);
	}, [formValues.contactNumber, Verifi, savedNumber]);

	return (
		<Box display="flex" alignItems="center" gap={2}>
			{verified && (
				<TextField
					label="Contact Number"
					placeholder="Enter Contact Number"
					value={formValues.contactNumber}
					size="small"
					onChange={(e) => handleChange('contactNumber', e.target.value)}
					required
					error={Boolean(errors.contactNumber)}
					helperText={errors.contactNumber || ''}
					fullWidth
					disabled={verified}
					InputProps={{
						sx: { fontSize: { xs: 14, sm: 18 } },
					}}
					FormHelperTextProps={{
						sx: { fontSize: 10 }, // 👈 helper/error text size
					}}
				/>
			)}

			{/* Show Verify Button if not verified */}
			{!verified ? (
				<Button
					variant="outlined"
					color="primary"
					fullWidth
					onClick={() => setVerificationContact(true)}
					startIcon={verifyIcon === 'check' ? <CheckCircleIcon /> : <PhoneIphoneIcon />}
				>
					Verify Number
				</Button>
			) : (
				<IconButton color="success" disabled>
					<CheckCircleIcon color="success" />
				</IconButton>
			)}
		</Box>
	);
}
